import { useBoundStore } from '@Store/useBoundStore';
import { OnboardingFormFields } from '@Types/index';
import type { IBusinessAdress } from '@Types/address';

export const useSyncBusinessAddressSlice = () => {
  const setCustomerData = useBoundStore((state) => state.setCustomerData);
  const customer = useBoundStore((state) => state.customer);

  const syncBusinessAddress = (input: IBusinessAdress) => {
    const customerToUpdate = { ...customer };
    customerToUpdate.customerData.businessAddressData.line1 = input[OnboardingFormFields.LINE1];
    customerToUpdate.customerData.businessAddressData.country =
      input[OnboardingFormFields.COUNTRY]?.code;

    customerToUpdate.customerData.businessAddressData.line2 = input[OnboardingFormFields.APARTMENT];
    customerToUpdate.customerData.businessAddressData.city = input[OnboardingFormFields.CITY];
    customerToUpdate.customerData.businessAddressData.state =
      input[OnboardingFormFields.STATE]?.value;
    customerToUpdate.customerData.businessAddressData.postalCode = input[OnboardingFormFields.ZIP];
    customerToUpdate.customerData.businessAddressData.sameAsPrimary =
      input[OnboardingFormFields.BUSINESS_ADDRESS_SAME_AS_PRIMARY];
    setCustomerData(customerToUpdate);
  };

  return { syncBusinessAddress };
};
